// @ts-expect-error TS6133 -- MIGRATION: not approved, fix when encountered
import React, { useCallback, useEffect, useRef } from 'react'
import { PopUp, PrimaryButton, SecondaryButton, Dropdown } from 'ui_kit_qmd'
import closeIcon from '../../../../images/common/close.png'
import { CANCEL_TEXT, CONFIRM_TEXT } from '../../../../utils/constants'
import './UpdateStatusPopUp.scss'

const successPopUpBoxStyle = {
  display: 'flex',
  width: 623,
  height: 300,
  flexDirection: 'column',
  alignItems: 'center',
  flexShrink: 0,
}

const defaultPopUpBoxStyle = {
  marginTop: 100,
  width: 717,
  height: 527,
  borderRadius: 4,
}

export const UpdateStatusPopUp = ({
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  selectedStatus,
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  setSelectedStatus,
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  onHoldReason,
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  setOnHoldReason,
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  isOpen,
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  onClose,
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  onConfirm,
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  isPatientStatusChangedSuccess,
  popUpTitle = 'On hold status',
  popUpBodyText = 'Changing the compliance status...',
}) => {
  const initialStatusRef = useRef(null)
  const initialReasonRef = useRef('')

  useEffect(() => {
    if (isOpen) {
      initialStatusRef.current = selectedStatus
      initialReasonRef.current = ''
      setOnHoldReason('')
    }
  }, [isOpen])

  // Close popup handler
  const onClosePopup = useCallback(() => {
    if (onClose) {
      setSelectedStatus(initialStatusRef.current)
      onClose()
    }
  }, [onClose])

  // Confirm button handler
  const onConfirmAction = useCallback(() => {
    const trimmedReason = onHoldReason.trim()
    const hasChanged = selectedStatus !== initialStatusRef.current || trimmedReason !== initialReasonRef.current

    if (hasChanged) {
      onConfirm(selectedStatus, trimmedReason) // Fire request only if something changed
    } else {
      setSelectedStatus(initialStatusRef.current)
      onClosePopup()
    }
  }, [onConfirm, selectedStatus, onHoldReason, onClosePopup])

  if (!isOpen) {
    return null
  }

  return (
    <PopUp
      content={
        <div className='on-hold-popup-main-container'>
          <span
            role='button'
            tabIndex={0}
            aria-label='Close'
            onClick={onClose}
            onKeyDown={(e) => {
              if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault()
                onClosePopup()
              }
            }}
            className='on-hold-popup-close-icon'>
            <img src={closeIcon} alt='' />
          </span>
          <div className='on-hold-popup-content'>
            <h2 className='on-hold-popup-title'>{popUpTitle}</h2>
            <p className='on-hold-popup-subtitle'>{popUpBodyText}</p>
            <div className='on-hold-dropdown-container'>
              <Dropdown
                label=''
                isWithoutLabel
                options={['Must complete drug screen', 'Must complete in-person visit', 'On hold', 'Compliant']}
                value={selectedStatus}
                setValue={setSelectedStatus}
              />
            </div>
            <textarea
              className='on-hold-textarea'
              placeholder='Type something...'
              value={onHoldReason}
              onChange={(e) => setOnHoldReason(e.target.value)}
            />
            <div className='on-hold-buttons-row'>
              <PrimaryButton
                onPress={onConfirmAction}
                btnText={CONFIRM_TEXT}
                containerStyle={{
                  width: '290px',
                  height: '56px',
                  marginRight: '32px',
                }}
                useUpdatedStyle
              />
              <SecondaryButton
                onPress={onClosePopup}
                btnText={CANCEL_TEXT}
                labelStyle={{ fontSize: '20px', fontWeight: '700', color: '#00818D' }}
                containerStyle={{ borderColor: '#E6E6E6', width: '290px', height: '56px' }}
              />
            </div>
          </div>
        </div>
      }
      popUpBoxStyle={isPatientStatusChangedSuccess ? successPopUpBoxStyle : defaultPopUpBoxStyle}
      successText='Compliance status updated!'
      isSuccess={isPatientStatusChangedSuccess}
      className='on-hold-popup-container'
    />
  )
}
